// Story 7.25 — the always-mounted half of the re-accept gate.
//
// Watching the store flag costs nothing; the dialog costs react-markdown.
// This wrapper is what App.tsx mounts, and it lazy-imports the dialog only
// when the gate actually raises — the same NFR-Perf-9 reasoning that keeps
// LegalDocPage out of the initial chunk (it and this dialog share the
// markdown renderer, so the split keeps that dependency fully out of the
// index bundle). A null Suspense fallback is right here: the gate raising
// means the app behind it is already showing failed queries, and a spinner
// racing a ~50KB chunk fetch would only flicker.

import { Suspense, lazy } from "react";

import { useTosStale } from "./tosGateStore";

const TosReacceptDialog = lazy(() =>
  import("./TosReacceptDialog").then((m) => ({
    default: m.TosReacceptDialog,
  })),
);

export function TosReacceptGate() {
  const stale = useTosStale();
  if (!stale) return null;
  return (
    <Suspense fallback={null}>
      <TosReacceptDialog />
    </Suspense>
  );
}
